import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.MediaFile.Save.IRequest;
type Response = Api.Core.MediaFile.Save.IResponse;
type Headers = Api.Core.MediaFile.Save.IHeaders;
const url = '/api/MediaFile';
export default async function mediaFileSave(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
